/** P0.4 — sectores de clientes: multiselección acotada (§Bloque 0 v0.3). */

export const MAX_SECTORES = 5;
export const SECTOR_MULTIPLE = 'multiples_sin_predominio';

/**
 * Lee el valor serializado con `|` quedándose solo con códigos vigentes.
 * Los borradores anteriores guardaban una sola vertical (ej. `fintech`), y esos
 * códigos ya no existen: si se contaran, ocuparían cupos invisibles.
 */
export function parseSectores(valor: string, validos: readonly string[]): string[] {
  const permitidos = new Set(validos);
  const elegidos: string[] = [];
  for (const codigo of valor.split('|')) {
    if (permitidos.has(codigo) && !elegidos.includes(codigo)) elegidos.push(codigo);
  }
  return elegidos.slice(0, MAX_SECTORES);
}

/** Alterna un sector respetando el tope y la exclusividad de "múltiples sectores". */
export function toggleSector(actuales: readonly string[], sector: string): string[] {
  if (actuales.includes(sector)) return actuales.filter((x) => x !== sector);
  if (sector === SECTOR_MULTIPLE) return [SECTOR_MULTIPLE];

  const sinMultiple = actuales.filter((x) => x !== SECTOR_MULTIPLE);
  if (sinMultiple.length >= MAX_SECTORES) return sinMultiple;
  return [...sinMultiple, sector];
}

export function serializarSectores(sectores: readonly string[]): string {
  return sectores.join('|');
}
